import React, { useState } from "react";
import { brandingConfig } from "../../content/config/branding";
import { useDevice } from "../../context/DeviceContext";

/**
 * Componente Switch personalizado con soporte responsive y efectos avanzados
 * @param {Object} props - Propiedades del componente
 * @param {boolean} props.checked - Estado del switch (activo/inactivo)
 * @param {Function} props.onChange - Función callback para manejar cambios de estado
 * @returns {JSX.Element} Componente Switch renderizado
 */
const Switch = ({
  checked = false,
  onChange,
  disabled = false,
  id,
  ...props
}) => {
  const { isMobile } = useDevice();
  const [isActive, setIsActive] = useState(false);

  const handleChange = (e) => {
    if (!disabled && onChange) {
      onChange(e.target.checked);
    }
  };

  // Variables CSS dinámicas basadas en el dispositivo
  const buttonWidth = isMobile ? 3.5 : 2.8; // em
  const buttonHeight = isMobile ? 2 : 1.6; // em
  const toggleDiameter = isMobile ? 1.5 : 1.2; // em
  const buttonToggleOffset = (buttonHeight - toggleDiameter) / 2;
  const toggleShadowOffset = isMobile ? 10 : 8; // px
  const toggleWider = isMobile ? 3 : 2.4; // em (para efecto de expansión)

  // Colores del tema
  const colorGrey = "#cccccc";
  const colorActive = brandingConfig.colors.primary;

  const handleMouseDown = () => setIsActive(true);
  const handleMouseUp = () => setIsActive(false);
  const handleMouseLeave = () => setIsActive(false);

  return (
    <label
      className={`inline-block cursor-pointer ${
        disabled ? "opacity-50 cursor-not-allowed" : ""
      }`}
      onMouseDown={handleMouseDown}
      onMouseUp={handleMouseUp}
      onMouseLeave={handleMouseLeave}
    >
      <input
        type="checkbox"
        checked={checked}
        onChange={handleChange}
        disabled={disabled}
        style={{ display: "none" }}
      />
      <span
        style={{
          display: "inline-block",
          width: `${buttonWidth}em`,
          height: `${buttonHeight}em`,
          backgroundColor: checked ? colorActive : colorGrey,
          borderRadius: `${buttonHeight / 2}em`,
          position: "relative",
          transition: "0.3s all ease-in-out",
          fontSize: isMobile ? "16px" : "14px",
        }}
      >
        <span
          style={{
            content: "",
            display: "inline-block",
            width:
              isActive && checked
                ? `${toggleWider}em`
                : isActive && !checked
                ? `${toggleWider}em`
                : `${toggleDiameter}em`,
            height: `${toggleDiameter}em`,
            backgroundColor: "#fff",
            borderRadius: `${toggleDiameter / 2}em`,
            position: "absolute",
            top: `${buttonToggleOffset}em`,
            left: checked
              ? isActive
                ? `${buttonWidth - toggleWider - buttonToggleOffset}em`
                : `${buttonWidth - toggleDiameter - buttonToggleOffset}em`
              : `${buttonToggleOffset}em`,
            boxShadow: checked
              ? `${-toggleShadowOffset}px 0 ${
                  toggleShadowOffset * 4
                }px rgba(0, 0, 0, 0.1)`
              : `${toggleShadowOffset}px 0 ${
                  toggleShadowOffset * 4
                }px rgba(0, 0, 0, 0.1)`,
            transition: "0.3s all ease-in-out",
          }}
        />
      </span>
    </label>
  );
};

export default Switch;
